import {Component} from 'react';
import Notify from 'notifyjs'
import {client} from '../../Client';
import Moment from 'moment';
import 'react-date-picker/index.css'
import PropTypes from 'prop-types';

class AttivitaNotification extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notificheFatte : 0,
            elapsed: Date.now(), // secondi passati dall'ultima notifica
        };
        this.doNotification = this.doNotification.bind(this)
        this.onPermissionGranted = this.onPermissionGranted.bind(this)
        this.onPermissionDenied = this.onPermissionDenied.bind(this)
        this.onNotifyShow = this.onNotifyShow.bind(this)
        this.onUpdateInterval = this.onUpdateInterval.bind(this)

    }

    componentDidMount() {
        this.audio = new Audio('/sounds/bell_ring.mp3');
        this.updateInterval = setInterval(this.onUpdateInterval, 1000*5); // Ogni 5 secondi
    }

    componentWillUnmount() {
        clearInterval(this.updateInterval);
    }

    onUpdateInterval(){
        // Verificare se ci sono le condizioni per la notifica.
        let giornoCorrente = (this.props.giorno === Moment().format("YYYY-MM-DD") );
        let elapsedFromLastNotification = ((Date.now() - this.state.elapsed)/(1000*60));
        let title = 'Registrazione Attività';
        let message = 'Ricordati di registrare la tua attività giornaliera';

        let testElapsed = elapsedFromLastNotification >= client.getConfigurazione().attivitaNotificationRepeat;

        // nuova versione (modificata ilo 16/07/2018)
        if (this.props.attivitaCorrente === undefined) {
            if (this.props.attivitaComplete === undefined || this.props.attivitaComplete.length === 0)
            {
                message = 'Nessuna attività registrata oggi!';
            }
            else
            {
                message = 'Nessuna registrazione.\nUltima su:' + this.props.attivitaPrecedente.idCommessa.codice;
            }
        }
        else{
            let ac = this.props.attivitaCorrente;
            message = ac.nomeBreve;
        }

        // vecchia versione (modificata ilo 16/07/2018)
        // if (this.props.attivitaCorrente === undefined){
        //     if (this.props.attivitaComplete === undefined || this.props.attivitaComplete.length === 0)
        //     {
        //         testAttivita = true;
        //         message = 'Ancora nessuna attività registrata oggi!\nDovresti avviare una nuova attività';
        //     }
        //     else
        //     {
        //         let oraFine = this.props.attivitaPrecedente.fine;
        //         let dtOraFine = new Date(oraFine);
        //         let elapsedFormLastActivity = ((Date.now() - dtOraFine)/(1000*60));
        //         testAttivita = elapsedFormLastActivity >= this.state.attivitaNotificationDelay;
        //         message = 'E\' passato diverso tempo dalla fine dell\'ultima attività registrata.\nDovresti avviare una nuova attività';
        //     }
        // }

        console.log("CFG Enabled, Repeat", client.getConfigurazione().attivitaNotificationEnabled, client.getConfigurazione().attivitaNotificationRepeat);
        console.log("elapsedFromLastNotification: " ,elapsedFromLastNotification);
        console.log("message: " ,message);
        console.log("notify? giornoCorrente, props.attive, testElapsed", giornoCorrente , this.props.attive , testElapsed );

        if ( (giornoCorrente && this.props.attive && client.getConfigurazione().attivitaNotificationEnabled &&  testElapsed)){
            this.notify(title, message)
            this.setState({
                notificheFatte: ++this.state.notificheFatte,
                elapsed: Date.now(),
            })
        }
    }

    notify(title, msg){
        let image = new Image();
        image.src = this.props.imageContent;

        this.salvaImmagine(this.props.imageContent, (url) => {

            this.myNotification = new Notify(title, {
                body: msg,
                notifyShow: () => this.onNotifyShow(),
                notifyClick: (ev) => this.onNotifyClick(ev),
                timeout: 30,
                // icon: '/images/logo-sbpiu.png',
                icon: url,
                //image: null,
                silent: false,
                requireInteraction: false,
            });

            if (!Notify.needsPermission) {
                this.doNotification();
            } else if (Notify.isSupported()) {
                Notify.requestPermission(this.onPermissionGranted, this.onPermissionDenied);
            }

        });
    }

    onNotifyShow() {
        this.audio.play();
    }

    onNotifyClick(ev){
        const clickedNotification = ev.target;
        clickedNotification.close();
    }

    onPermissionGranted() {
        this.doNotification();
    }

    onPermissionDenied() {
        console.warn('Permission has been denied by the user');
    }

    doNotification() {
        this.myNotification.show();
    }

    componentWillReceiveProps(nextProps, nextContext){
        if (
            nextProps.attivitaCorrente !== this.props.attivitaCorrente ||
            nextProps.attivitaPrecedente !== this.props.attivitaPrecedente ||
            nextProps.attivitaCompletate !== this.props.attivitaCompletate
        ){
            // Riparte con il conteggio del conto alla rovescia per la successiva notifica
        }
    }

    salvaImmagine(imgData, cb) {

        this.setState({_loading: true});
        client.saveChartRiepilogoOrario(imgData).then((response) => {
            if (response.ok){
                response.json().then((data) => {

                    this.setState({
                        _loading: false,
                        inError: false,
                        fieldErrors: {},
                        fieldErrorsText: [],
                    });
                    if (cb){
                        cb(client.getApiBaseUrl() + data.url);
                    }
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }            else
            {
                response.json().then((error) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}

                    if (error.errors !== undefined){
                        Object.keys(error.errors).map((item) => {
                            fieldErrors[item] = true;
                            fieldErrorsText = fieldErrorsText.concat(item + ":" +error.errors[item]);
                            return 0;
                        });
                    }
                    else {
                        fieldErrorsText = [error.message]
                    }
                    this.setState({
                        _loading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle:error.title,
                        inError: true
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                fieldErrors: {},
                fieldErrorsText: [error.message],
                errorTitle: "Errore di rete imprevisto",
                inError: true
            });
        });

    }

    render() {
        return (null)
    }
}

AttivitaNotification.PropTypes = {
    attivitaCorrente: PropTypes.object.isRequired,      // Attività corrente, se iniziata. Altrimenti undefined.
    attivitaPrecedente: PropTypes.object.isRequired,  // Ultima Attività registrata nel giorno se sistente. Altrimenti undefined.
    attivitaComplete: PropTypes.array.isRequired,
    giorno: PropTypes.string.isRequired,
    commessa: PropTypes.object.isRequired,
    attive: PropTypes.bool.isRequired,
}


export default AttivitaNotification;




/** WEBPACK FOOTER **
 ** ./src/components/attivita/AttivitaNotification.jsx
 **/